class WorkOrders {
  constructor(api) {
    this.api = api;
  }

  getAll(queryParams, onSuccess, onError) {
    let params = "";
    for (const [query, value] of Object.entries(queryParams)) {
      params += params === "" ? "?" : "&";
      params += query + "=" + value;
    }
    return this.api.http_weezie_fiber
      .get("api/v1/workorders" + params)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  sendTemplateDataFilter(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/workorders/objects", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  getWorkOrderByUUID(uuid, queryParams, onSuccess, onError) {
    let params = "";
    for (const [query, value] of Object.entries(queryParams)) {
      params += params === "" ? "?" : "&";
      params += query + "=" + value;
    }
    return this.api.http_weezie_fiber
      .get("api/v1/workorders/" + uuid + params)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  deleteWorkOrderByUUID(uuid, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .delete("api/v1/workorders/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  createWorkOrder(data, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .post("api/v1/workorders", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  exportWorkOrder(uuid, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get(`api/v1/workorders/${uuid}/export`,{responseType: 'arraybuffer'})
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  updateWorkOrder(data, uuid, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .put("api/v1/workorders/" + uuid, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  sendBulkActivities(activities, uuid, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .post("api/v1/workorders/" + uuid + "/activities", {
        activities: activities
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  updateBulkActivities(activities, uuid, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .put("api/v1/workorders/" + uuid + "/activities", {
        activities: activities
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getWorkOrderActivities(uuid, queryParams, onSuccess, onError) {
    let params = "";
    for (const [query, value] of Object.entries(queryParams)) {
      params += params === "" ? "?" : "&";
      params += query + "=" + value;
    }
    return this.api.http_weezie_fiber
      .get("api/v1/workorders/" + uuid + "/activities" + params)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getWorkOrderObjects(uuid, queryParams, onSuccess, onError) {
    let params = "";
    for (const [query, value] of Object.entries(queryParams)) {
      params += params === "" ? "?" : "&";
      params += query + "=" + value;
    }
    return this.api.http_weezie_fiber
      .get("api/v1/workorders/" + uuid + "/objects" + params)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  priorityList(onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/lists/priorities")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default WorkOrders;



// WEBPACK FOOTER //
// ./src/api/workOrders.js